/**
 * @name emojiRegex
 */
export const emojiRegex =
  /([\u2000-\u2017]|\ud83c[\ud000-\udfff]|\ud83d[\ud000-\udfff]|\ud83e[\ud000-\udfff])\s?/gi;
